"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsText() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Text
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A polymorphic text component with typography variants for consistent text styling.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/text" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Heading Variants</CardTitle>
              <CardDescription>Different heading sizes</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-4"
        >
          <Text as="h1" className="text-h1">Heading 1</Text>
          <Text as="h2" className="text-h2">Heading 2</Text>
          <Text as="h3" className="text-h3">Heading 3</Text>
          <Text as="h4" className="text-h4">Heading 4</Text>
          <Text as="h5" className="text-h5">Heading 5</Text>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Body Text</CardTitle>
              <CardDescription>Paragraph and body text styles</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-4"
        >
          <Text className="text-lg">Large body text for emphasis.</Text>
          <Text>Regular body text for general content.</Text>
          <Text className="text-sm">Small body text for secondary information.</Text>
          <Text className="text-xs text-muted-foreground">Extra small muted text.</Text>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">as</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"p" | "span" | "h1" | "h2" | etc.</td>
                <td className="py-2 font-mono text-xs">"p"</td>
                <td className="py-2 text-muted-foreground">HTML element to render</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">className</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 font-mono text-xs">-</td>
                <td className="py-2 text-muted-foreground">Typography and style classes</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
